import { withTranslation } from 'react-i18next';
import { ISelectAvatarItemViewProps } from './interfaces';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Tooltip,
} from '@mui/material';
import { useStyles } from './styles';
import { DeleteIcon } from '@icons/DeleteIcon';
import { EditIcon } from '@icons/EditIcon';
import { ReactComponent as GenericAvatarIcon } from '@public/images/generic_avatar.svg';
import { colors } from '@constants/colors';

const SelectAvatarItemView = ({
  avatar,
  isSelectedAvatar,
  setSelectedAvatar,
  editAvatarClick,
  deleteAvatarClick,
  canEdit,
  canDelete,
  t: translate,
}: ISelectAvatarItemViewProps) => {
  const classes = useStyles(isSelectedAvatar);

  return (
    <Box sx={classes.root}>
      <Card sx={classes.card}>
        <Box sx={classes.avatarPicContainer}>
          {avatar?.avatarPic && (
            <CardMedia
              component="img"
              image={avatar.avatarPic}
              alt="Avatar Miniature"
              sx={classes.avatarPic}
              onClick={() => {
                setSelectedAvatar(avatar);
              }}
            />
          )}
          {!avatar?.avatarPic && (
            <Box
              sx={classes.emptyAvtarPic}
              onClick={() => {
                setSelectedAvatar(avatar);
              }}
            >
              <GenericAvatarIcon style={{ fill: colors.black }} />
            </Box>
          )}
        </Box>
        <CardContent sx={classes.actions}>
          <Tooltip
            title={translate('tooltips.deleteAvatar')}
            componentsProps={{
              tooltip: {
                sx: {
                  textAlign: 'center',
                },
              },
            }}
          >
            <IconButton
              disableRipple
              sx={classes.action(canDelete)}
              onClick={() => deleteAvatarClick(avatar)}
            >
              <DeleteIcon sx={classes.actionIcon} />
            </IconButton>
          </Tooltip>
          <Tooltip title={translate('tooltips.edit')}>
            <IconButton
              disableRipple
              sx={classes.action(canEdit)}
              onClick={() => editAvatarClick(avatar)}
            >
              <EditIcon sx={classes.actionIcon} />
            </IconButton>
          </Tooltip>
        </CardContent>
      </Card>
    </Box>
  );
};

export default withTranslation()(SelectAvatarItemView);
